import React from 'react';

import logoSecurty from './assets/security.png'
import logoOpenpay from './assets/openpay2.png'

import  logoRayados from './../../assets/logo.png';

//import ApolloClient from 'apollo-boost';
import { gql } from "apollo-boost";
import Reaptcha from 'reaptcha';

import './style.css';

type MyProps = {
  actionComplete:any
  clientAPollo:any
}
type MyState = { 
  nombre: string, 
  numero:string,  
  tarjetaMes:string
  tarjetaAno:string
  cvv:string

  tarjetaMesList:string[]
  tarjetaAnoList:string[]
  id:string
  cantidad:number | null

  token_id:string
  device_session_id:string
  use_card_points:boolean
  cupon_code:string
  type:string

  captcha_verified:boolean
  captcha_code:string
};


export class OpenPayError extends Error {
  type:string
  constructor(message: string,type: string="") {
    super(message);
    this.name = "OpenPayError";
    this.type = type
  }
}



export class FormOpenPay extends React.Component<MyProps, MyState>{
  submit: any;
  submitcupon: any;
  captcha:any;

  // https://es.reactjs.org/docs/forms.html#controlled-components Componentes controlados
  constructor(props:any) {
    super(props)

    let hoy = new Date();
    let yearToday:number=parseInt(hoy.getFullYear().toString().substr(-2));

    let tarjetaMesList:string[]=[]
    for(let i=1; i<=12;i++)
      tarjetaMesList.push(i.toString().padStart(2,"0"));

    let tarjetaAnoList:string[]=[]
      for(let i=yearToday; i<yearToday+10;i++)
      tarjetaAnoList.push(i.toString());      


    this.state = {
      nombre: '',
      numero: '',
      tarjetaMes:"01",
      tarjetaAno:yearToday.toString(),
      cvv:"",
      tarjetaMesList:tarjetaMesList,
      tarjetaAnoList:tarjetaAnoList,

      id:'',
      cantidad:null, 
      
      token_id:"",
      device_session_id:"",
      use_card_points:false,

      cupon_code:"",
      type:"CARD",

      captcha_verified:false,
      captcha_code:""
    }

    // avoid: onClick={this.handleChange.blind(this)}
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSubmitCupon = this.handleSubmitCupon.bind(this);
  }

  handleChange(event: React.ChangeEvent<any>) {
    let { name, value } = event.currentTarget;
    this.setState({[name] : value} as any);
  }

  async handleSubmitCupon(event:any){
    event.preventDefault();

    this.submitcupon.setAttribute("disabled", "disabled");

    try{
      console.log("Se intento hacer el pago con cupon");
      let response=await this.props.clientAPollo.mutate({
        mutation: gql`
             mutation setPayCardboardFanRegister($id:ID, $cupon_code:String, $captcha_code:String){
              setPayCardboardFanRegister(id:$id input:{cupon_code:$cupon_code,captcha_code:$captcha_code} type:CUPON){
                id,
                nombre,
                email
             }}`,
            variables:this.state
        });          

        console.log("Se completo el pago");
      this.props.actionComplete(response.data.setPayCardboardFanRegister)

    }catch(e){
      console.log("ERROR:",JSON.stringify(e))
      //@ts-ignore
      Sentry.captureException(e);

      
      if(e.message.startsWith('GraphQL')){
          let mensaje=e.message.replace("GraphQL error: ","");
          if(mensaje==="cupon not found") alert("El código que ingresaste es incorrecto o no existe. Por favor, valida la información e inténtalo nuevamente.");
          else if(mensaje==="cupon it was used.") alert("El código que ingresaste ya ha sido utilizado.");
          else alert("GMSG:"+mensaje);
      }else{
          alert(e.message);
      }

        
      
      this.submitcupon.removeAttribute("disabled")

      this.setState({captcha_verified: false,captcha_code:''});
      this.captcha.reset();
    }
    
  }

  onVerify = (code:string) => {
    this.setState({captcha_verified: true,captcha_code:code});
  };  

  async handleSubmit(event:any) {
    event.preventDefault();

    this.submit.setAttribute("disabled", "disabled");

    try{
      console.log("Se intento tokenisar");

      let responseToken:any=await new Promise((resolve,reject) => {
        //@ts-ignore
        OpenPay.token.extractFormAndCreate('payment-form',(success) =>resolve(success),(error:any) =>{
          reject(new OpenPayError(error.data.description))
        });
      });
      console.log("Se tokeniso");

      this.setState({
        token_id:responseToken.data.id,
        //@ts-ignore
        device_session_id:OpenPay.deviceData.setup("payment-form", "device_session_id")
      })

      console.log("Se intento hacer el pago");
      let response=await this.props.clientAPollo.mutate({
        mutation: gql`
             mutation setPayCardboardFanRegister($id:ID, $token_id:String, $device_session_id:String){
              setPayCardboardFanRegister(id:$id input:{token_id:$token_id,device_session_id:$device_session_id}){
                id,
                nombre,
                email
             }}`,
            variables:this.state
        });          

        console.log("Se completo el pago");
      this.props.actionComplete(response.data.setPayCardboardFanRegister)

    }catch(e){
      console.log("ERROR:",JSON.stringify(e))
      //@ts-ignore
      Sentry.captureException(e);

      alert(e.message)

      this.submit.removeAttribute("disabled")
    }

  }

  updateState=(newStates:object)=> this.setState(newStates);

  render(){
    return (    
      <div className="formulario" >
        <img src={logoRayados}  className="fpmg_logo" alt="Rayads" />

              <h3>Folio: {this.state.id}</h3>
              
    
              <div className="typeTabs">
                <h4><a href="#" onClick={(e) =>{ this.setState({type:'CARD'})}}  className={this.state.type==="CARD"?'hit':''}>Cargo con tarjeta de crédito o débito</a></h4>
                <h4><a href="#" onClick={(e) =>{ this.setState({type:'CUPON'})}} className={this.state.type==="CUPON"?'hit':''}>CANJEAR CÓDIGO</a></h4>
              </div>
              {this.state.type==="CARD"?
              <form  id="payment-form" onSubmit={this.handleSubmit} >
               <div className="infoTarjetas group2cols">
                  <div className="trj-part">
                    <strong>Tarjetas de crédito:</strong>
                    Visa, Mastercard, American Express y Carnet.
                  </div>
                <div className="trj-part">
                    <strong>Tarjetas de débito:</strong>
                    BBVA Bancomer, Banorte, Banamex, HSBC, Scotiabank,  Santander, IXE, Banco Azteca e Inbursa.
                </div>
               </div>               
                <input type="hidden" name="token_id" id="token_id" />
                <input type="hidden" name="device_session_id"  value={this.state.device_session_id} onChange={this.handleChange} />
                
                <input type="hidden" name="use_card_points" id="use_card_points" value="false" />

                 <div className="form-group">
                   <small className="form-text">Nombre del titular</small>
                   <input type="text" className="form-control required" name="nombre" value={this.state.nombre} onChange={this.handleChange} data-openpay-card="holder_name" autoComplete="off"  required />
                 </div>
                 <div className="form-group">
                   <small className="form-text">Número de tarjeta</small>
                   <input type="number" className="form-control" name="numero" value={this.state.numero} onChange={this.handleChange} autoComplete="off" data-openpay-card="card_number" required />
                 </div>
                 <div className="group2cols">
                   <div className="form-group">
                     <small  className="form-text">Fecha de expiración</small>
                     <div className="group2cols">
                         <div>
                           <select className="form-control" value={this.state.tarjetaMes} onChange={this.handleChange} name="tarjetaMes"  data-openpay-card="expiration_month">
                             {this.state.tarjetaMesList.map((element:any) =>{
                              return (<option key={element} value={element} >{element}</option>)
                             })}
                           </select>
                           <small className="form-text small">Mes</small>
                         </div>
                         <div>
                           <select className="form-control" value={this.state.tarjetaAno}  name="tarjetaAno" onChange={this.handleChange} data-openpay-card="expiration_year">
                            {this.state.tarjetaAnoList.map((element:any) =>{
                              return (<option key={element}  value={element} >{element}</option>)
                             })}                             
                          </select>  
                           <small  className="form-text small">Año</small>
                         </div>                        
                     </div>                                          
                   </div>
                   <div className="form-group">
                     <small className="form-text">Código de seguridad</small>
                     <input type="number" className="form-control required" name="cvv" value={this.state.cvv} onChange={this.handleChange} placeholder=""  data-openpay-card="cvv2" required />
                     <small  className="form-text small">CVV</small>
                   </div>  
                 </div>
                 <div className="lastColum">
                    <div className="cantidadAPagar">
                        Donativo:  ${this.state.cantidad}
                    </div>
                    <div className="form-group openpayInfo">
                        <div className="shield">Tus pagos se realizan de forma segura con encriptación de 256 bits <img src={logoSecurty} alt="Logo encriptación de 256" /></div>   
                        <div className="openpay">Transacciones realizadas vía:  <img src={logoOpenpay} alt="Logo openpay"/></div>
                    </div>
                 </div>    
                 <div className="buttom">
                  <input type="submit" ref={itemRef => {this.submit = itemRef}}  className="btn  btn-block btn-fpmg" value="Realizar pago" />
                </div>
               </form>                
                 :
                 <form  id="payment-form-cupon" onSubmit={this.handleSubmitCupon} >
                    <div className="form-group cupon-code">
                      <small className="form-text">Código del cupón</small>
                      <input type="text" className="form-control required" name="cupon_code" value={this.state.cupon_code} onChange={this.handleChange} autoComplete="off"  required />
                    </div>

                    <Reaptcha ref={e => (this.captcha = e)} sitekey="6LcydwATAAAAAJORex8IFl-HjpQ_f-7iMLmnRGS_" onVerify={this.onVerify} />

                  <div className="buttom">
                    <input type="submit" ref={itemRef => {this.submitcupon = itemRef}}  className="btn  btn-block btn-fpmg" value="Canjear cupón" disabled={!this.state.captcha_verified} />
                  </div>
                </form>
                }

            
        </div>               
      )
    }
}



// https://github.com/uxitten/polyfill/blob/master/string.polyfill.js
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/padStart
if (!String.prototype.padStart) {
  String.prototype.padStart = function padStart(targetLength, padString) {
      targetLength = targetLength >> 0; //truncate if number, or convert non-number to 0;
      padString = String(typeof padString !== 'undefined' ? padString : ' ');
      if (this.length >= targetLength) {
          return String(this);
      } else {
          targetLength = targetLength - this.length;
          if (targetLength > padString.length) {
              padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
          }
          return padString.slice(0, targetLength) + String(this);
      }
  };
}